import React, { useContext } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import { Button } from 'nike-ui/src/components/button/Button';

import i18n from '@i18n';
import AddIcon from 'nike-ui/src/icons/svg/add-icon-sv.svg';
import { copyTicketFromDetail } from '@/mytickets/detail/handlers';
import BetLocationContext from 'nike-ui/src/common/BetLocationContext';
import BetbookContext from 'nike-ui/src/common/BetbookContext';
import { fromJS } from 'immutable';
import { accountUserData$ } from '@/account/subs';

function Restore({ ticketId, createDraftCmd, saved, ticketType }) {
    const { subscribe } = useReframe();
    const betbookContext = useContext(BetbookContext);
    const betLocationContext = useContext(BetLocationContext);
    const betLocation = betLocationContext?.betLocationSection;
    const userData = subscribe(accountUserData$);
    const currentUserId = userData.cisloZmluvy;

    function click() {
        let createDraft = createDraftCmd || [];
        createDraft[2] = createDraft[2] ? createDraft[2] : {};
        // tu ma nezaujima co tvrdi createDraft z ticketusu, lebo ticketus nevie na akej obrazovke som
        // a betbook atributy sa posielaju len z betbookovych obrazoviek
        delete createDraft[2]['betbookId'];
        delete createDraft[2]['betbookContractId'];
        delete createDraft[2]['betbookTicketId'];

        if (saved) {
            createDraft[2].savedTicketId = ticketId;
        }
        if (betbookContext.betbookPostId) {
            createDraft[2]['betbookId'] = betbookContext.betbookPostId;
        }
        if (betbookContext.betbookPostType === 'TICKET' && currentUserId !== betbookContext.betbookPostAuthor) {
            createDraft[2]['betbookContractId'] = betbookContext.betbookPostAuthor;
            createDraft[2]['betbookTicketId'] = ticketId;
        }
        if (
            betbookContext.betbookPostType === 'ANALYSIS' &&
            betbookContext.betbookBetId &&
            betbookContext.betbookBetSelectionCode
        ) {
            createDraft[2]['betbookContractId'] = betbookContext.betbookPostAuthor;
            createDraft[2]['betbookPick'] = betbookContext.betbookBetId + '-' + betbookContext.betbookBetSelectionCode;
        }
        if (betLocation && createDraft) {
            createDraft[2].positionId = betLocation.id;
            createDraft[2].positionCode = betLocation.code;
        }
        dispatch(copyTicketFromDetail(fromJS(createDraft), ticketType));
    }
    return (
        <Button
            primary
            className="blue"
            dataAtid="ticket-detail-add-to-ticket"
            icon={AddIcon}
            label={i18n('jsp.tiket.use')}
            onClick={click}
        />
    );
}

export default Restore;
